import axios from "axios";
import getSignature from "../Common/getSignature";
import { toast } from "react-toastify";

//Live APIs — overridable per environment through .env (see .env for local development)
export const API_BASE_PATH_ADMIN =
  process.env.REACT_APP_API_BASE_PATH_ADMIN || "https://apis.polybionictechnologies.co/admin";
export const API_BASE_PATH_USER =
  process.env.REACT_APP_API_BASE_PATH_USER || "https://apis.polybionictechnologies.co/user";
export const API_BASE_PATH_USER_LOGIN =
  process.env.REACT_APP_API_BASE_PATH_USER_LOGIN || "https://polybionictechnologies.co/dashboard";

export const SOCKET_SERVER_URL_WSS =
  process.env.REACT_APP_SOCKET_SERVER_URL_WSS || "wss://apis.polybionictechnologies.co";


console.log("API_BASE_PATH_ADMIN", API_BASE_PATH_ADMIN);

const axiosInstance = axios.create({
  baseURL: API_BASE_PATH_ADMIN,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const signatureHeaders = await getSignature();
    const { authorization, ...restSignatureHeaders } = signatureHeaders || {};
    const authToken = localStorage.getItem("authToken");
    config.headers = {
      ...config.headers,
      ...restSignatureHeaders,
    };

    if (!config.headers["Content-Type"] && !(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }

    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    } else {
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

/** 401 on these routes is a real auth failure (e.g. wrong password), not an expired access token. */
const isPublicAuthRequest = (url) => {
  if (!url || typeof url !== "string") return false;
  const path = url.split("?")[0];
  return path === "/login" || path.endsWith("/login");
};

const refreshAccessToken = async () => {
  try {
    const signatureHeaders = await getSignature();
    const response = await axios.post(
      `${API_BASE_PATH_ADMIN}/refresh-token`,
      {},
      {
        withCredentials: true,
        headers: {
          ...signatureHeaders,
        },
      }
    );

    console.log("response----------", response);

    const newAccessToken = response.data.token;
    if (newAccessToken) {
      localStorage.setItem("authToken", newAccessToken);
      return newAccessToken;
    } else {
      throw new Error("New access token not received during refresh.");
    }
  } catch (error) {
    console.error("Token refresh failed:", error);
    localStorage.clear();
    window.location.href = "/";
    toast.error(
      error.response.data.message ||
        "Your session has expired. Please log in again."
    );
    return Promise.reject(error);
  }
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !isPublicAuthRequest(originalRequest.url)
    ) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axiosInstance(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }
      isRefreshing = true;

      return new Promise(async (resolve, reject) => {
        try {
          const newAccessToken = await refreshAccessToken();
          originalRequest.headers["Authorization"] = "Bearer " + newAccessToken;
          processQueue(null, newAccessToken);
          resolve(axiosInstance(originalRequest));
        } catch (refreshError) {
          processQueue(refreshError, null);
          reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      });
    }

    const body = error?.response?.data;
    let code = body?.code || 0;
    console.log(error);
    const message =
      body?.message ||
      body?.msg ||
      (typeof body?.error === "string" ? body.error : body?.error?.message) ||
      body?.isMobile?.message ||
      body?.isEmail?.message ||
      body?.isStrongPassword?.message ||
      error?.message ||
      error?.response?.statusText ||
      "An error occurred";

    console.log("message", message);
    console.log(
      "error?.response?.data?.message",
      error?.response?.data?.message
    );
    console.log("error?.data?.error", error?.data?.error);

    error?.config?.showToast && toast.error(message || "Request failed");
    return Promise.reject({ data: null, error: { code, message: message } });
  }
);

const apiCall = async (method, endpoint, data = null, showToast = false) => {
  try {
    const config = {
      method: method,
      url: endpoint,
      // data: data,
      showToast: showToast,
    };
    if (data instanceof FormData) {
      config.data = data;
    } else if (data) {
      config.data = data;
    }
    const response = await axiosInstance(config);
    console.log(endpoint, response.data);
    showToast && toast.success(response.data.message || "Request success");
    return { data: response.data, error: null };
  } catch (error) {
    if (error && error.error) {
      return error;
    }
    return {
      data: null,
      error: {
        code: error.code || 0,
        message: error.message || "An unexpected error occurred",
      },
    };
  }
};

export default apiCall;
